module.exports = __webpack_public_path__ + "images/avatars/male/10.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/10.png
// module id = NnQa
// module chunks = 51